import { skipToken, useQuery } from "@tanstack/react-query"
import { fetchEnergyPassport } from "@/entities/energy-passport/api/fetch-energy-passport.ts"
import type { IFetchEnergyPassportParams } from "@/entities/energy-passport/types.ts"
import { energyPassportQueryKeys } from "@/features/energy-passport/api/query-keys.ts"

export const useFetchEnergyPassport = (params: Partial<IFetchEnergyPassportParams>) => {
  return useQuery({
    queryKey: energyPassportQueryKeys.list(params),
    queryFn: params?.contractId && params?.year ? () => fetchEnergyPassport(params as IFetchEnergyPassportParams) : skipToken
  })
}
